import defaultSettings from '@/settings'

const title = defaultSettings.title || '远程医疗协同平台'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/utils/getPageTitle.js